var React = require('react');

function IconBitvavoInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"72","height":"72","style":{"fill":"none"},"key":0}),React.createElement("path",{"d":"M32.1,14.21H49.71l-26,43.58H6.13Z","style":{"fill":"currentColor","fillRule":"evenodd"},"key":1}),React.createElement("path",{"d":"M48.27,35.86h17.6l-13,21.93H35.28Z","style":{"fill":"currentColor","fillRule":"evenodd"},"key":2})]);
}

IconBitvavoInline.defaultProps = {"viewBox":"0 0 72 72"};

module.exports = IconBitvavoInline;

IconBitvavoInline.default = IconBitvavoInline;
